import React from "react";
import { Group } from "@mantine/core";
import CustomButton from "../../ui/CustomButton/CustomButton";

const PaymentHeader = ({
  title,
  description,
  buttonText,
  buttonIcon,
  onButtonClick,
}) => {
  return (
    <div className="mb-10 border-b pb-6">
      <Group justify="space-between" align="center" mb="sm" wrap="wrap" gap="sm">
        <div>
          <h1 className="text-base sm:text-xl font-semibold text-gray-900">{title}</h1>
          <p className="text-xs sm:text-sm text-gray-600 mt-1">{description}</p>
        </div>

        <CustomButton
          variant="primary"
          color="blue"
          radius="xl"
          leftSection={buttonIcon}
          onClick={onButtonClick}
        >
          {buttonText}
        </CustomButton>
      </Group>
    </div>
  );
};

export default PaymentHeader;
